import { RestAPI } from '../RestAPI'

export const getBuildDocsAPIToken = (
  organizationInn: string,
): Promise<string> =>
  RestAPI.get(`/tokens/api-token/generate`, {
    headers: { organizationInn },
  }).then(res => res.data || '')
